import styled from 'styled-components';

export const DashboardNavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2.5rem 3.8rem;
`;
